module.exports = "/public/images/0fb1ee9c43ef982b585382d3709bb7b5.svg";